import React, { createContext, useContext, useState, useCallback } from 'react';
import QuoteDialog from '../components/common/QuoteDialog';
import StickyCallBar from '../components/common/StickyCallBar';
import { Toaster } from '../components/ui/sonner';

const QuoteContext = createContext({ openQuote: () => {} });

export const useQuote = () => useContext(QuoteContext);

export const QuoteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [defaultService, setDefaultService] = useState('');

  const openQuote = useCallback((service = '') => {
    setDefaultService(service);
    setOpen(true);
  }, []);

  return (
    <QuoteContext.Provider value={{ openQuote }}>
      {children}
      <QuoteDialog open={open} onOpenChange={setOpen} defaultService={defaultService} />
      <StickyCallBar />
      <Toaster position="top-center" richColors closeButton />
    </QuoteContext.Provider>
  );
};

export default QuoteProvider;
